export default {
  wechart: 'WeChart',
  common: {
    copyright: '広州幂動科技有限会社 Copyright',
  },
  route: {
    home: 'トップページ',
    aso: 'ASO',
    ytoutiao: '悦頭条',
    tbaoke: 'Taobao客',
    contactus: 'お問い合わせ',
  },
  home: {
    head: {
      textLine1: '私たちは',
      textLine2: 'モバイルインタネットビッグデータマーケティングプラットフォームの先駆者です',
      subText: '全てのインタネットリソースをマトリックスでカバーし、効率的に収益に繋がるビジネスプランを提案します',
    },
    content1: {
      yTitle: '私たちの強み',
      contentItem1: '媒体のカバー範囲が広い',
      contentItem2: '様々な広告タイプ',
      contentItem3: '先進的なデータ技術',
      contentItem4: '精確なレコメンデーションアルゴリズム',
    },
    content2: {
      contentItem1: {
        mainContent: 'IOSワンストップ式マーケティングソリューションの提案',
        subContent: 'アップロード/スピーディ審査、ワード選定、ASO/ASM, データトラッキング、口コミ改善、業界レポートを含む一連のIOS総合マーケティングサービスを提供します',
      },
      contentItem2: {
        mainContent: 'インフィード広告',
        subContent: '月間アクティブユーザー500万人以上の情報系アプリ「悦頭条」を持ち、開屏広告（アプリ起動時のフルスクリーン広告）、バナー広告、インフィード広告、インスピレーション動画、アプリワォールなど、様々な方式の広告を提供しており、レコメンデーションアルゴリズムによって広告主に最適な優良ユーザーを見つけます',
      },
      contentItem3: {
        mainContent: 'Taobao客',
        subContent: 'アプリマトリックス＋wechatグループのシステムがTaobao客トラフィックの基礎になります。シェアアプリ「特優恵」で、チャネルには代理商と顧客を管理するツールを、お店には優良なチャネルを、そして顧客に各オンラインショッピングサイトのお得なクーポンを提供します',
      },
    },
    cooperator: 'パートナーズ',
  },
  contactus: {
    headProp: {
      textLine1: '私たちは、失敗を恐れず、努力を惜しまず、活気のあるチームです',
      textLine2 : '広告をよりスマートに',
      subTexts : ['広州幂动科技有限会社は、中国国内トップの総合モバイルマーケティングサービスカンパニーです。効率的且つ高品質的でビッグデータを収集、運営し、独特なwechat,アプリ立体化フローマトリックスを用い、世界の顧客にワンストップ式マーケティングソリューションを提案します。幂动科技は、モバイルデバイスマルチデータに繋がり、媒体プロパティ及びユーザータグによってデータを階層化し管理します。その上、ターゲッティング広告の手法を用い、マルチターゲッティングアプローチします。私たちは、アフィリエイト広告、アプリストア検索最適化、ブランディング広告など様々なサービスを提供します。現在、Tencent, Baidu, Ali, Jingdong ,今日頭条、咪咕など中国国内の一流会社にサービスを提供しています。',
      '幂动科技のメンバーは、清華大学、中山大学など名門大学を卒業し、Tencent, Wangyi,SogouなどのIT一流企業で働く経験を持っています。メンバーはKDDなど世界トップレベルの学会で論文を発表し、Topcoderなど国際コーディング大会で世界6位の好成績を獲得したこともあります。',
        ]
    },
    glory: {
      title: '幂动受賞歴',
      imageGlory: 'http://sucai003.oss-cn-qingdao.aliyuncs.com/midong/ja/glory.png'
    },
    contact: {
      title: 'お問い合わせ',
      subTitle: '7日*24時間　随時サービスを提供します',
      contactItem1: 'IOSワンストップマーケティングソリューション',
      contactItem2: '悦頭条',
      contactItem3: '悦頭条',
    }
  }
}



// WEBPACK FOOTER //
// ./src/lang/ja.js